import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.manage-passwords', {
        url: '/:groupId/manage-passwords',
        params: {groupId: null},
        views: {
            '@company.manage-application': 'companyManageApplicationUsersManagePasswords'
        },
		resolve: {
			groupId,
        },
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/manage-passwords/manage-passwords.state.js